import { omit } from 'lodash'
import BaseApi from '@/api/Base/BaseApi'
import {
  CreateExternalModelPayload,
  UpdateExternalModelPayload,
  GetExternalModelListResponse,
  GetHuggingFaceModelListResponse,
  ImportHuggingFaceModelPayload,
  HuggingFaceModelFilterType,
  HuggingFaceModel,
  CreateExternalModelNodePayload,
  ExternalModelNodeInfo
} from '@/api/ExternalModel/types'

import { ModelValueType } from '@/pages/const'

const ROOT = '/external-model'

export default class ExternalModelApi extends BaseApi {
  createExternalModel(payload: CreateExternalModelPayload) {
    const { modelName, modelType, description, zipFile, workspaceId, inferenceModel = true } = payload

    const formData = new FormData()

    formData.append('modelType', modelType)
    formData.append('modelName', modelName)
    formData.append('workspaceId', workspaceId)
    formData.append('zipFile', zipFile)
    formData.append('inferenceModel', inferenceModel.toString())

    if (description) {
      formData.append('description', description)
    }

    return this.agent.post(`${ROOT}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  deleteExternalModel(externalModelId: string) {
    return this.agent.delete(`${ROOT}/${externalModelId}`)
  }

  updateExternalModel(payload: UpdateExternalModelPayload) {
    const { externalModelId, ...rest } = payload

    return this.agent.put(`${ROOT}/${externalModelId}`, omit(rest, ['workspaceId']))
  }

  getExternalModelList(workspaceId: string, params: { page: number, itemsPerPage?: number }) {
    const { page, itemsPerPage = 3 } = params

    return this.agent.get<GetExternalModelListResponse>(`${ROOT}/${workspaceId}`, {
      params: {
        page,
        num_per_page: itemsPerPage,
      },
    })
  }

  createExternalModelNode(payload: CreateExternalModelNodePayload) {
    const { projectId, ...rest } = payload

    return this.agent.post<ExternalModelNodeInfo>(`/project/${projectId}/externalModelNode/create`, rest)
  }

  getExternalModelNodeDetail(externalModelNodeId: string) {
    return this.agent.get<ExternalModelNodeInfo>(`external-model-node/${externalModelNodeId}`)
  }

  getHuggingFaceModelList(workspaceId: string, params: { page: number, filterType?: HuggingFaceModelFilterType, itemsPerPage?: number }) {
    const { page, filterType = 'ALL', itemsPerPage = 10 } = params

    return this.agent.get<GetHuggingFaceModelListResponse>(`/huggingFaceModel/${workspaceId}`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        filterType,
      },
    })
  }

  getEnabledHuggingFaceModelList(workspaceId: string, modelType: ModelValueType) {
    return this.agent.get<HuggingFaceModel[]>(`/huggingFaceModel/${workspaceId}/list`, {
      params: {
        modelType,
      },
    })
  }

  importHuggingFaceModel(payload: ImportHuggingFaceModelPayload) {
    const { workspaceId, ...rest } = payload

    return this.agent.put(`/huggingFaceModel/${workspaceId}`, rest)
  }
}
